export default [
  { link: '/', text: 'Home'},
  { link: '/about', text: 'About'},
  // { link: '/designs', text: 'Designs'},
  { link: '/contact', text: 'Contact'},
];
